import script from "./AIView.vue?vue&type=script&setup=true&lang=js"
export * from "./AIView.vue?vue&type=script&setup=true&lang=js"

import "./AIView.vue?vue&type=style&index=0&id=67a31383&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a31383"]])

export default __exports__